var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-snackbar',{attrs:{"timeout":8000,"color":_vm.snackbar_color,"multi-line":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.snackbar_text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }